var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 880 880",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m463.226257,30l156.52734,286.90234l-69.52734,67.09766l-86.18416,-155l-238.93549,444.99441l243.15046,-0.24281l57.96919,101.2484l-363,0l-40,75l-121,0l461,-820z",
    id: "svg_1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m783.294757,319l-251.9607,248.11377l204.77636,282.2337l-120.81566,0.65253l-127,-247l-48.60614,40.36076l-129.39386,-0.36076l169,-319l30.00277,49.15625l-79.00277,192.84375l270.21802,-251.44679l82.78198,4.44679z",
    id: "svg_2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m677.773757,483l200,367l-107,0l-163.92398,-293.78839l70.92398,-73.21161z",
    id: "svg_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9498a928e1ff6bc70f6ff2606329da2e.svg";
export { ForwardRef as ReactComponent };